import { api } from './api';

// GET SOS events (cursor-paginated; params: limit, cursor, status, type)
export const getSosEvents = (params?: any) => api.get('/admin/safety/sos-events', { params });

// RESOLVE an SOS event (optional resolution note)
export const resolveSosEvent = (id: number, note?: string) =>
    api.patch(`/admin/safety/sos-event/${id}/resolve`, note ? { note } : {});

// Mint a FRESH follow link for the event's ride (admin view outlives public expiry)
export const getSosFollowLink = (id: number) =>
    api.get<{ token: string; url: string }>(`/admin/safety/sos-event/${id}/follow-link`);
